import Icon from '../components/Icon.vue'

Icon.register({
  'toilet-paper-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M64 192c0-10.8 0.5-21.3 1.4-31.7l316 244.3c-4.2 32.2-12.9 57.7-22.2 85.5-4.2 12.7-16.2 21.9-30.3 21.9h-0.1-280.9c-8.8 0-15.9-7.2-15.9-16 0-1.7 0.3-3.4 0.8-5 21.4-64.1 31.1-85.8 31.1-126.9v-172.1zM633.8 458.1c3.8 2.9 6.2 7.5 6.2 12.7 0 3.7-1.3 7.1-3.4 9.8l-19.6 25.3c-2.9 3.8-7.5 6.2-12.7 6.2-3.7 0-7.1-1.3-9.8-3.4l-588.4-454.7c-3.8-2.9-6.2-7.5-6.2-12.6 0-3.7 1.3-7.1 3.4-9.8l19.6-25.3c2.9-3.8 7.5-6.2 12.6-6.2 3.7 0 7.1 1.3 9.8 3.4l53.3 41.2c16.6-27.7 37.9-44.5 61.3-44.5h284.5c-36.9 38.5-60.5 108.4-60.5 192v73l50.4 39c-11.4-31.6-18.4-70-18.4-112 0-106 43-192 96-192s96 86 96 192c0 92.3-32.7 168.9-76.2 187.3zM512 256c17.6 0 32-28.6 32-64s-14.4-64-32-64-32 28.6-32 64 14.4 64 32 64z'
      }
    ]
  }
})
